<div class="code-verification__content" role="group" [attr.aria-label]="ariaLabel">
  <p class="code-verification__label">Enter the code we sent to your {{ requestTypeText }}</p>

  <div class="code-verification__field">
    <app-code-input
      [formControl]="codeControl"
      [attr.aria-label]="ariaLabel"
      (keyup.enter)="on_enter()">
    </app-code-input>

    <p class="code-verification__error" aria-live="polite">
      @if (codeControl.invalid && codeControl.touched) {
        {{ validationService.getFieldErrorMessage('Verification Code', codeControl,
           'Please enter the 6-digit code.') }}
      }
    </p>
  </div>

  <div class="code-verification__resend">
    <span>Didn't receive the code?</span>
    <button
      matButton
      type="button"
      [disabled]="!resendEnabled"
      (click)="onClick_resendCode()">
      {{ resendEnabled ? 'Try again' : 'Try again in ' + resendCounter + 's' }}
    </button>
    <span aria-live="polite" class="cdk-visually-hidden">{{ ariaResendStatus }}</span>
  </div>

  @if (showSubmitButton) {
    <button matButton class="code-verification__submit" type="button"
      (click)="onClick_submit()"
      [disabled]="modal && (appService.pageLoading$ | async)">
      @if ((modal && !(appService.pageLoading$ | async)) || !modal) {
        <span>{{ 'Verify ' + (requestTypeText | titleCasePipe) }}</span>
      }
      @if (modal && (appService.pageLoading$ | async)) {
        <mat-spinner diameter="20"></mat-spinner>
      }
    </button>
  }
</div>
